module.exports = {
    HOME: '/',
    ABOUT_US: '/about-us',
    CONTACT: '/contact',
    EBOOKS: '/ebooks',
    INDUSTRIES: '/industries',
    NEWSLETTER: '/newsletter',
    PRODUCTS: '/product',
    PRICING: '/pricing',
    PRICING_CALL_AND_SMS: '/pricing/call-and-sms',
    TERMS: '/terms-and-conditions',
    ISO: '/iso',
    CAREERS: '/careers',
    CASESTUDIES: '/casestudies',
    PRESENTATION_FORM: '/introduction',
    PRESS_CENTRE: '/press-centre',
    PARTNERS: '/partners',
    INTEGRATIONS: '/product/integrations',
    REMOTE_WORK: '/remote-work',
    NEWS: '/whats-new',
    LOGIN: '/login',
    REGISTER: '/register',
    API: '/api',
    DOCUMENTATION: '/documentation',
    BLOG: '/blog',
    DSA_FORM: '/dsa',
}
